import type { DevScenario } from '@arya/shared/domain';

export interface ScenarioGroup {
  readonly name: string;
  readonly scenarios: readonly DevScenario[];
}

export const scenarioGroups = (scenarios: readonly DevScenario[]): readonly ScenarioGroup[] =>
  [...new Set(scenarios.map(({ group }) => group))].map((name) => ({
    name,
    scenarios: scenarios.filter(({ group }) => group === name),
  }));

export const pickedPerGroup = (
  scenarios: readonly DevScenario[],
  active: readonly string[]
): Readonly<Record<string, string>> =>
  Object.fromEntries(scenarios.filter(({ name }) => active.includes(name)).map(({ group, name }) => [group, name]));
